export const {
  MODE: ENVIRONMENT,
  VITE_APP_VERSION: APP_VERSION,
  VITE_APP_API_URL: API_URL,
  VITE_APP_API_VERSION: API_VERSION,
  VITE_APP_SENTRY_DSN: SENTRY_DSN,
  VITE_APP_STRIPE_CLIENT_ID: STRIPE_CLIENT_ID,
  VITE_APP_STRIPE_KEY: STRIPE_KEY,
  VITE_APP_MAPBOX_KEY: MAPBOX_KEY,
  VITE_APP_FULLCALENDAR_LICENSE_KEY: FULLCALENDAR_LICENSE_KEY,
  VITE_REVERB_APP_KEY: REVERB_APP_KEY,
  VITE_REVERB_HOST: REVERB_HOST,
  VITE_REVERB_PORT: REVERB_PORT,
  VITE_REVERB_SCHEME: REVERB_SCHEME,
  VITE_APP_TREMENDOUS_DOMAIN: TREMENDOUS_DOMAIN,
  VITE_APP_TREMENDOUS_CLIENT_ID: TREMENDOUS_CLIENT_ID,
  VITE_APP_TREMENDOUS_REDIRECT_URI: TREMENDOUS_REDIRECT_URI,
  VITE_APP_WEBPUSH_PUBLIC_KEY: WEBPUSH_PUBLIC_KEY,
  VITE_APP_INSTAGRAM_CLIENT_ID: INSTAGRAM_CLIENT_ID,
  VITE_APP_INSTAGRAM_REDIRECT_URI: INSTAGRAM_REDIRECT_URI,
  VITE_APP_BRIGHTPATTERN_TENANT_URL: BRIGHTPATTERN_TENANT_URL,
} = import.meta.env;
